/**************************************************
 * Nombre:       Tarjeta_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Collapse, Grid, Typography} from "@mui/material";
import {useState} from "react";
import {theme} from "../../Tema";
import Tarjeta_Variante from "./Tarjeta_Variante";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Productos = ({item}) => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();
    const [esTodos, setEsTodos] = useState(false);
    const [open, setOpen] = useState(false);


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid

                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    border: 1, borderColor: '#00000040',
                    "&:hover": {
                        borderColor: theme.palette.primary.main,
                        border: 2
                    }
                }}
            >

                <Grid
                    onClick={() => navigate('/Detalle/' + item.id)}
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{cursor: 'pointer'}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <img src={item?.img} alt="botella" width="75%" height="auto"/>
                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{pb: 0, px: 2, mt: 2}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography
                                sx={{fontSize: sCell ? 10 : 12, fontWeight: 600, color: theme.palette.primary.main}}>
                                {item?.marca}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', minHeight: sCell ? 'auto' : 54}}>
                            <Typography
                                sx={{fontSize: sCell ? 18 : 16, fontWeight: 600, color: '#000000', lineHeight: 1.1}}>
                                {item?.nombre}
                            </Typography>
                        </Grid>


                    </Grid>

                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{pb: 2, px: 2}}
                >

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={1}
                        sx={{mt: 1, height: sCell ? 'auto' : 80}}
                    >

                        <Typography sx={{
                            fontSize: 14,
                            lineHeight: 1.4,
                            textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 4,

                        }}>
                            {item?.etiquetas?.map((item, index) => {

                                return (
                                    <span onClick={() => navigate(`/Catalogo/Etiqueta/${item}`)}
                                          className={'etiqueta'}
                                    >
                                        {item + ', '}
                                    </span>
                                )

                            })}
                        </Typography>

                    </Grid>

                </Grid>

            </Grid>


            <Collapse in={open} timeout="auto" sx={{width: '100%'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                    sx={{mt: 2}}
                >


                    {item && item.variantes && item.variantes.map((it, index) => {
                        return (
                            <Grid key={`s5${index}`} container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Variante item={it} producto={item}/>
                            </Grid>
                        )
                    })}

                </Grid>

            </Collapse>

            <Button
                onClick={() => setOpen(!open)}
                fullWidth sx={{mt: 2}}>
                {open ? 'Ver Menos' : 'Ver Precios'}

            </Button>

        </Grid>
    )

}
export default Tarjeta_Productos



